import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {PanierService} from '@app/core';
import {ICartItem, ILineV2} from '@app/shared';
import {find} from 'lodash';
import {MatRadioChange} from '@angular/material';

@Component({
    selector: 'app-select-bed',
    templateUrl: './select-bed.component.html',
    styleUrls: ['./select-bed.component.scss']
})
export class SelectBedComponent implements OnInit {
    @Input() model: ILineV2;
//    @Input() model: {
//        idRoom: number,
//        idLine: number,
//        occupation: string,
//        keybedSelected: string,
//        bedding: Array<any>
//    };
    keybedSelected: string;
    bedding: Array<any>;
    ref: number
    @Output() changeBedEvent = new EventEmitter<any>();

    constructor(private panierService: PanierService) {}

    ngOnInit() {
        this.ref = Math.floor(Math.random() * 100);
        this.keybedSelected = this.model.keybedSelected;
        this.bedding = this.model.bedding;
    }

    changeBadRadio(event: MatRadioChange) {
//        console.log('changeBadRadio', event);
        this.changeBad(event.value)
    }
    
    changeBad(value) {
        // console.log('changeBad', value)
        this.model.keybedSelected = this.keybedSelected = value;
        let itemCart: ICartItem = find(this.panierService.getItems(), {idRoom: this.model.idRoom, idLine: this.model.idLine, occupation: this.model.occupation});
        // console.log(itemCart);
        if (itemCart) {
            itemCart.keybed = this.keybedSelected;
            itemCart.valbed = this.getValbed(this.keybedSelected);
            this.changeBedEvent.emit({keybed: itemCart.keybed, valbed: itemCart.valbed});
        }
        // console.log(this.panierService.getItems());
    }

    private getValbed(keyBed): Array<any> {
        let valBed = [];
        let bed = this.bedding.find((i) => i.key == keyBed);
        if (bed) {
            valBed = JSON.parse(JSON.stringify(bed.value));
        }
        return valBed;
    }
}
